/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { MenuComponent } from '../../../../../../../_metronic/assets/ts/components'
import { ID, KTSVG, QUERIES } from '../../../../../../../_metronic/helpers'
import { useListView } from '../../core/ListViewProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { archiveTemplate } from '../../core/_requests'
import { duplicateDocument } from '../../../../../../../jsFunctions'

type Props = {
  id: ID
}

const TemplateActionsCell: FC<Props> = ({ id }) => {
  const { setItemIdForUpdate, setItemIdForDelete } = useListView()
  const [deleteId, setDeleteId] = useState<ID>()
  const { query } = useQueryResponse()
  const queryClient = useQueryClient()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const openEditModal = () => {
    setItemIdForUpdate(id)
  }

  // const showDeleteId = (deleteId: ID) => {
  //   alert(deleteId)
  // }

  // const duplicate = useMutation(() => duplicateDocument(id, "_templates"), {
  //   onSuccess: () => {
  //     queryClient.invalidateQueries([`${QUERIES.EVENTS_LIST}-${query}`]);
  //   },
  // });

  // const deleteItem = useMutation(() => archiveTemplate(id), {
  //   // 💡 response of the mutation is passed to onSuccess
  //   onSuccess: () => {
  //     // ✅ update detail view directly
  //     queryClient.invalidateQueries([`${QUERIES.TEMPLATES_LIST}-${query}`])
  //   },
  // })

  return (
    <div>
      <a
        href='#'
        className='btn btn-light btn-active-light-primary btn-sm'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        Actions
        <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-5 m-0' />
      </a>
      {/* begin::Menu */}
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4'
        data-kt-menu='true'
      >
        {/* begin::Menu item */}
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={openEditModal}>
            Edit
          </a>
        </div>
        {/* end::Menu item */}

        {/* begin::Menu item */}
        {/* <div className='menu-item px-3'>
          <a className='menu-link px-3'  onClick={async () => await duplicate.mutateAsync()}>
            Duplicate
          </a>
        </div> */}
        {/* end::Menu item */}

        {/* begin::Menu item */}
        <div className='menu-item px-3'>
          <a
            type="button"
            className="menu-link px-3"
            data-bs-toggle="modal"
            data-bs-target="#kt_modal_1"
            data-kt-templates-table-filter='delete_row'
            onClick={() => setItemIdForDelete(id)}
            // onClick={async () => await deleteItem.mutateAsync()}
          >
            Archive
          </a>
        </div>
        {/* end::Menu item */}



      </div>
      {/* end::Menu */}
    </div>
  )
}

export { TemplateActionsCell }
